import { render, staticRenderFns } from "./EditColour.vue?vue&type=template&id=7eaa1a5e"
import script from "./EditColour.vue?vue&type=script&lang=js"
export * from "./EditColour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports